export default __webpack_public_path__ + "static/media/fairy_with_questions.9dcb0f45.png";